import { render } from "./FeaturesSection.vue?vue&type=template&id=bdbdccac&scoped=true"
import script from "./FeaturesSection.vue?vue&type=script&lang=js"
export * from "./FeaturesSection.vue?vue&type=script&lang=js"

import "./FeaturesSection.vue?vue&type=style&index=0&id=bdbdccac&lang=scss&scoped=true"

import exportComponent from "/Users/jackwaghorn/Documents/Projects/VibeLab/XP/Xp mircosite/xp-v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdbdccac"]])

export default __exports__